import React from 'react';
import type { StateCart } from '@spa/lib/store/carts/CartsState';

export interface HeightSinceWidthEntry {
  readonly sinceWidth: number;
  readonly height: number;
}

export type HeightSinceWidth = Array<HeightSinceWidthEntry>;

export interface PlaceholderConfig {
  readonly ratio?: number;
  readonly heightSinceWidth?: HeightSinceWidth;
  readonly content?: React.ReactElement;
}

export interface PlaceholderContextValues {
  readonly cart: StateCart | null;
  readonly dynamicEnvelopComponentsMap:
    | import('@spa/components/dynamicComponentsMap/dynamicComponentConfig').DynamicComponentConfigMap
    | null;
}

export const PlaceholderContext = React.createContext<PlaceholderConfig>({});
